// page-for-content-creaters.jsx — コンテンツクリエイター向け

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;

  const SUPPORT = [
    { num:'01', t:'会計・税務',         d:'個人事業主・法人化までの相談から、月次仕訳・確定申告・節税設計まで。クリエイター業特有の経費・著作権収益にも対応。' },
    { num:'02', t:'契約・法務',         d:'業務委託・原稿料・印税・出演料の契約レビュー、報酬未払い対応のサポート。' },
    { num:'03', t:'バックオフィス代行', d:'請求書発行・入金管理・経費精算・取引先管理まで kintone と AI で省力化。' },
    { num:'04', t:'広報・編集',         d:'プロフィール文・メディア掲載・出版企画・登壇／取材対応まで、編集チームが伴走。' },
  ];

  function ForContentCreatorsPage() {
    return (
      <HBLayout>
        <HBSubHero
          crumb={`Other / コンテンツクリエイター向け`}
          en="For content creators"
          jp={<span>つくることに、<br/><span style={{color:hbcp.blue}}>集中できる</span>環境を。</span>}
          tag={'Backoffice for makers, by makers.'}
          lead={'クリエイター・ライター・編集者・登壇者・YouTuberなど、個人で価値を生み出す方のためのバックオフィス支援。会計／税務／契約／請求／広報までワンストップで支援します。'}
        />

        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Support areas</span>
              <span className="hb-section-head-jp">対応領域</span>
            </div>
            <div style={{display:'grid', gridTemplateColumns:'repeat(2, 1fr)', borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`}}>
              {SUPPORT.map(u => (
                <div key={u.num} style={{padding:'40px 32px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}}>
                  <div style={{fontFamily:fontEN, fontWeight:300, fontSize:36, color:hbcp.blue, marginBottom:12}}>{u.num}</div>
                  <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:22, lineHeight:1.4, margin:'0 0 12px'}}>{u.t}</h3>
                  <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:0}}>{u.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section style={{padding:'96px 32px', background:hbcp.blue, color:'#fff'}}>
          <div style={{maxWidth:1280, margin:'0 auto', display:'grid', gridTemplateColumns:'1.4fr 1fr', gap:64, alignItems:'flex-end'}}>
            <div>
              <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', opacity:.85, marginBottom:18}}>● CONTACT</div>
              <h2 style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(34px, 4.2vw, 50px)', lineHeight:1.4, margin:'0 0 24px'}}>
                確定申告から事務所設立まで、<br/>"つくる人"のチームでいます。
              </h2>
            </div>
            <div style={{display:'grid', gap:14}}>
              <a href={`${HB_BASE}/contact`} style={{padding:'18px 28px', background:'#fff', color:hbcp.blue, textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:700, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>無料相談を予約する</span><span style={{fontFamily:fontEN}}>→</span>
              </a>
              <a href={`${HB_BASE}/document-request`} style={{padding:'18px 28px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.6)', textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:600, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>資料請求をする</span><span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>
      </HBLayout>
    );
  }

  Object.assign(window, { ForContentCreatorsPage });
})();
